import { tryDoFetchWithRedirect } from "../../../lib/tryDoFetchWithRedirect";
import { getSid } from "lib/routing";

export const doChangePw = async (newPw) => {
  const newPassword = btoa(newPw);
  const sid = getSid().replace(/\s/g, "+"); // note server url encoding issues
  const body = JSON.stringify({ sid, newPassword });
  const json = await tryDoFetchWithRedirect("/research/japi/user/change-password", body, "POST"); // eslint-disable-line no-unused-vars
};
